import { render, staticRenderFns } from "./salesVolume.vue?vue&type=template&id=047c0587&scoped=true&"
import script from "./salesVolume.vue?vue&type=script&lang=js&"
export * from "./salesVolume.vue?vue&type=script&lang=js&"
import style0 from "./salesVolume.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./salesVolume.vue?vue&type=style&index=1&id=047c0587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c0587",
  null
  
)

component.options.__file = "salesVolume.vue"
export default component.exports